import { reactive } from 'vue'

// Global reactive store for soil analysis state
export const soilAnalysisStore = reactive({
  task: null,
  farm: null,
  soilTypes: [],
  selectedSoilType: null,
  
  // Method to initialize the store
  initialize(task, farm, soilTypes, selectedSoilType) {
    this.task = task;
    this.farm = farm;
    this.soilTypes = soilTypes;
    this.selectedSoilType = selectedSoilType;
  },
  
  // Method to update selected soil type
  updateSelectedSoilType(newSoilType) {

    
    this.selectedSoilType = newSoilType;

  },
  
  // Method to clear the store
  clear() {
    this.task = null;
    this.farm = null;
    this.soilTypes = [];
    this.selectedSoilType = null;
  }
});